import { render, staticRenderFns } from "./SymposiaCard.vue?vue&type=template&id=29e7fc3f&scoped=true"
import script from "./SymposiaCard.vue?vue&type=script&lang=js"
export * from "./SymposiaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e7fc3f",
  null
  
)

export default component.exports